"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseForm = void 0;
const core_api_1 = require("@ikegps/core-api");
const __1 = require("..");
const id_1 = require("../../id");
const BaseFormFactory_1 = require("./BaseFormFactory");
/**
 * BaseForm is any FormModel which has a Pole SubForm field.
 *
 * TODO: Add field mappings to Pole SubForm type and use those instead of PoleFieldIds for field lookups.
 */
class BaseForm {
    static create(hasVerticalSeparationToken = false) {
        const form = new __1.FormModel();
        const id = id_1.IkeId.generate();
        form.state.id = id;
        form.state.revision = id;
        form.state.rootFormId = id;
        const factory = new BaseFormFactory_1.BaseFormFactory(form, hasVerticalSeparationToken);
        factory.addBaseFormFields();
        factory.rootPoleSubForm();
        return factory.baseForm;
    }
    static isBaseForm(form) {
        return form.subFormType === core_api_1.SubFormType.POLE;
    }
    constructor(form) {
        this.form = form;
        if (!BaseForm.isBaseForm(form)) {
            throw new Error('BaseForm can only be constructed from a form with root subform type POLE');
        }
    }
    get poleField() {
        for (const field of [this.form, ...this.form.getFieldsRecursive]) {
            if (!__1.FormModelFieldSubForm.isSubForm(field)) {
                continue;
            }
            if (field.subFormType !== core_api_1.SubFormType.POLE) {
                continue;
            }
            return field;
        }
        throw new Error('Pole SubForm field not found in FormModel');
    }
    get statusField() {
        return this.poleField.getField(__1.PoleFieldIds.STATUS);
    }
    get sequenceField() {
        return this.poleField.getField(__1.PoleFieldIds.SEQUENCE);
    }
    get idField() {
        return this.poleField.getField(__1.PoleFieldIds.POLE_ID);
    }
    get tagPhotosField() {
        return this.poleField.getField(__1.PoleFieldIds.IMAGES);
    }
    get typeField() {
        return this.poleField.getField(__1.PoleFieldIds.POLE_TYPE);
    }
    get ownerField() {
        return this.poleField.getField(__1.PoleFieldIds.POLE_OWNER);
    }
    get circumferenceField() {
        return this.poleField.getField(__1.PoleFieldIds.CIRCUMFERENCE);
    }
    get tipField() {
        return this.poleField.getField(__1.PoleFieldIds.AGL);
    }
    get lowPowerAttachmentField() {
        return this.poleField.getField(__1.PoleFieldIds.LOW_POWER_ATTACHMENT);
    }
    get locationField() {
        return this.poleField.getField(__1.PoleFieldIds.GEOGRAPHIC_COORDINATE);
    }
    get streetAddressField() {
        return this.poleField.getField(__1.PoleFieldIds.STREET_ADDRESS);
    }
    get noteField() {
        return this.poleField.getField(__1.PoleFieldIds.NOTE);
    }
    get ikePhotoField() {
        return this.poleField.getField(__1.PoleFieldIds.IKE_PHOTO);
    }
    get lowPowerToCommField() {
        return this.poleField.getField(__1.PoleFieldIds.LOW_POWER_TO_COMM);
    }
    get equipmentField() {
        return this.poleField.getField(__1.PoleFieldIds.EQUIPMENT.FORM);
    }
    get anchorField() {
        return this.poleField.getField(__1.PoleFieldIds.ANCHOR.FORM);
    }
    get spanField() {
        for (const field of this.form.getFieldsRecursive) {
            if (!__1.FormModelFieldSubForm.isSubForm(field)) {
                continue;
            }
            if (field.subFormType !== core_api_1.SubFormType.SPAN) {
                continue;
            }
            return field;
        }
        throw new Error('Span SubForm field not found in FormModel');
    }
    get spanTypeField() {
        if (!this.spanField.subFormSpanTypeState) {
            throw new Error('Expected Span SubForm state to exist');
        }
        return this.spanField.getField(this.spanField.subFormSpanTypeState.typeFieldId);
    }
    get spanTypeMapping() {
        return {
            [__1.SpanType.NextPole]: __1.SpanType.PreviousPole,
            [__1.SpanType.PreviousPole]: __1.SpanType.NextPole,
            [__1.SpanType.Other]: __1.SpanType.Other,
        };
    }
    get spanVectorField() {
        if (!this.spanField.subFormSpanTypeState) {
            throw new Error('Expected Span SubForm state to exist');
        }
        return this.spanField.getField(this.spanField.subFormSpanTypeState.vectorFieldId);
    }
    get spanMidSpanIkePhoto() {
        if (!this.spanField.subFormSpanTypeState) {
            throw new Error('Expected Span SubForm state to exist');
        }
        if (!this.spanField.subFormSpanTypeState.midSpanIkePhotoFieldId) {
            throw new Error('Span is missing configured Mid Span IKE Photo field');
        }
        return this.spanField.getField(this.spanField.subFormSpanTypeState.midSpanIkePhotoFieldId);
    }
    get spanAttachmentHeightFields() {
        if (!this.spanField.subFormSpanTypeState) {
            throw new Error('Expected Span SubForm state to exist');
        }
        const field = this.spanWiresField.findField(__1.PoleFieldIds.SPAN.WIRE.ATTACHMENT_HEIGHT);
        return field ? [field] : [];
    }
    spanValue(instance) {
        return new __1.SpanSubFormAdaptor(instance);
    }
    get spanWiresField() {
        return this.spanField.getField(__1.PoleFieldIds.SPAN.WIRE.FORM);
    }
}
exports.BaseForm = BaseForm;
//# sourceMappingURL=BaseForm.js.map